import { render, staticRenderFns } from "./LedgerGroupForm.vue?vue&type=template&id=08ddbeec&scoped=true"
import script from "./LedgerGroupForm.vue?vue&type=script&lang=js"
export * from "./LedgerGroupForm.vue?vue&type=script&lang=js"
import style0 from "./LedgerGroupForm.vue?vue&type=style&index=0&id=08ddbeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ddbeec",
  null
  
)

export default component.exports